// DS: P20
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
import DollarSignIcon from '@wix/da-ds/pkg/Icons/16x16/DollarSign';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import s from './FolderRibbon.scss';
var FolderRibbon = function (_a) {
    var premiumFolderData = _a.premiumFolderData, className = _a.className;
    var t = useTranslation().t;
    var _b = normalizePremiumFolderData(premiumFolderData), isPremium = _b.isPremium, isPaidFolder = _b.isPaidFolder, isWatchToAccess = _b.isWatchToAccess;
    if (!isPremium) {
        return null;
    }
    var labelTransKey;
    if (isPaidFolder) {
        labelTransKey = 'folderCard.badge.premium';
    }
    if (isWatchToAccess) {
        labelTransKey = 'folderCard.badge.watchers';
    }
    return (React.createElement("div", { className: classnames(s['root'], isPaidFolder && s['premium'], isWatchToAccess && s['watchers'], className) },
        isPaidFolder && React.createElement(DollarSignIcon, { className: s['icon'] }),
        isWatchToAccess && React.createElement(FollowingWatchIcon, { className: s['icon'] }),
        React.createElement("span", { className: s['title'] }, t(labelTransKey))));
};
FolderRibbon.displayName = 'FolderRibbon';
export default FolderRibbon;
//# sourceMappingURL=FolderRibbon.js.map